<!-- eslint-disable max-len -->
<template>
    <div class="incubator-consent">
        <div class="apply-form-block">
            <div class="consent-container">
                <h2 class="consent-title">
                    {{ $t('IncubatorApply.Consent.title') }}
                </h2>
                <p class="consent-intro">
                    {{ $t('IncubatorApply.Consent.intro') }}
                </p>
                <p class="consent-intro">
                    {{ $t('IncubatorApply.Consent.pleaseRead') }}
                </p>
                <div class="consent-scroll-area">
                    <!-- 中文 -->
                    <template v-if="isZh">
                        <p class="lead">
                            財團法人中華民國佛教慈濟慈善事業基金會（下稱本會）依據個人資料保護法、本會之個人資料保護政策及辦法，在向您蒐集個人資料前，依法向您告知下列事項，敬請詳閱：
                        </p>
                        <div class="numbered-item">
                            <span class="num">一、</span>
                            <div class="content">
                                本會基於章程業務、活動、社會服務、行政管理及宣傳推廣活動等目的，蒐集、處理及利用個人資料。
                            </div>
                        </div>
                        <div class="numbered-item">
                            <span class="num">二、</span>
                            <div class="content">
                                本會蒐集之個人資料類別如填寫頁所示，請您填寫正確且最新及完整的個人資料，若有任何異動，請即時向本會更正。
                            </div>
                        </div>
                        <div class="numbered-item">
                            <span class="num">三、</span>
                            <div class="content">
                                本會蒐集、處理、利用、傳輸您個人資料之期間、地區、對象及方式如下：
                                <div class="sub-item">
                                    <span class="num">（一）</span>
                                    <div class="content">期間：本會僅於特定目的存續期間利用您個人資料，但因執行職務或業務所必須或經您同意者，不在此限。</div>
                                </div>
                                <div class="sub-item">
                                    <span class="num">（二）</span>
                                    <div class="content">地區：本會執行職務或業務之國內外地區。</div>
                                </div>
                                <div class="sub-item">
                                    <span class="num">（三）</span>
                                    <div class="content">對象：您個人資料將使用在本會、其他本會志業體、受本會委託處理相關事務之第三人、因履行契約所必要之第三人、其他業務相關之第三人、政府機構、其他未受中央目的事業主管機關限制國際傳輸之接收者。</div>
                                </div>
                                <div class="sub-item">
                                    <span class="num">（四）</span>
                                    <div class="content">方式：您個人資料將以自動化機器或其他非自動化之利用方式，並以合理方式使用。利用方式包括但不限於以言詞、書面、電話、簡訊、電子郵件、傳真、電子文件或其他合於當時科學技術之適當方式。</div>
                                </div>
                            </div>
                        </div>
                        <div class="numbered-item">
                            <span class="num">四、</span>
                            <div class="content">
                                您得到本會官網聯絡窗口，就您個人資料向本會行使以下權利：（一）查詢或請求閱覽。（二）請求製給複製本。（三）請求補充或更正。（四）請求停止蒐集、處理及利用。（五）請求刪除。<br>
                                本會得依個人資料保護法及相關法律規定、執行職務及業務所必須或經您書面同意時，拒絕您行使上述權利。<br>
                                若您因行使上述權利，而致權益受損時，本會將不負相關賠償責任。
                            </div>
                        </div>
                        <div class="numbered-item">
                            <span class="num">五、</span>
                            <div class="content">
                                您得自由選擇提供個人資料，如選擇您不提供個人資料，本會可能無法提供蒐集目的之相關服務。
                            </div>
                        </div>
                        <div class="numbered-item">
                            <span class="num">六、</span>
                            <div class="content">
                                若因本同意書涉訟，您同意以中華民國法律為準據法，並以臺灣花蓮地方法院為第一審管轄法院。
                            </div>
                        </div>
                        <div class="numbered-item">
                            <span class="num">七、</span>
                            <div class="content">
                                您同意本會留存此同意書，供日後取出查驗。
                            </div>
                        </div>
                        <div class="consent-notice">
                            <p class="notice-highlight">
                                ※您於相關文件填寫個人資料，即視為同意個人資料提供予本會，代表：
                            </p>
                            <p>您已閱讀、瞭解並同意接受本同意書之規定，並同意本會於所列蒐集目的之必要範圍內，蒐集、處理及利用本人之個人資料。</p>
                            <p>若您未滿十八歲，您確認已經法定代理人閱讀、瞭解並同意本同意書之所有內容，並遵守本同意書所有規範，始得填寫。</p>
                            <p>若您是代填報者，您保證已向個人資料所有人說明本同意書之內容，並獲得個人資料所有人之同意，始填報相關個人資料。</p>
                        </div>
                    </template>
                    <!-- English -->
                    <template v-else>
                        <p class="lead">
                            Buddhist Tzu Chi Charity Foundation (hereinafter referred to as the "Foundation"), in accordance with the Personal Data Protection Act and Personal Data Protection Policies and regulations of the Foundation, hereby informs you of the following matters prior to the collection of your personal data. Please kindly review:
                        </p>
                        <div class="numbered-item">
                            <span class="num">1.</span>
                            <div class="content">
                                The Foundation collects, processes, and uses personal data for the purpose of, including but not limited to, the business stipulated in the Articles of Incorporation, events, social services, administrative works, promotional and outreach activities.
                            </div>
                        </div>
                        <div class="numbered-item">
                            <span class="num">2.</span>
                            <div class="content">
                                The categories of personal data to be collected by the Foundation are as specified in the filling form. Please provide correct, updated, and complete personal data. In the event of any changes to the aforementioned data, please promptly notify the Foundation to make necessary corrections.
                            </div>
                        </div>
                        <div class="numbered-item">
                            <span class="num">3.</span>
                            <div class="content">
                                The time period, region, recipients, and methods of your personal data which the Foundation collects, processes, uses, and transmits are as follows:
                                <div class="sub-item">
                                    <span class="num">I.</span>
                                    <div class="content">Time period: The Foundation shall only use your personal data for as long as the aforementioned specific purposes remain valid, except where such use is either necessary for the performance of an official or business duty, or has been otherwise agreed to by you.</div>
                                </div>
                                <div class="sub-item">
                                    <span class="num">II.</span>
                                    <div class="content">Region: Within both domestic and foreign areas that are related to the performance of an official or business duty of the Foundation.</div>
                                </div>
                                <div class="sub-item">
                                    <span class="num">III.</span>
                                    <div class="content">Recipients: Your personal data will be used by the Foundation, other affiliated entities of the Foundation, any third party commissioned by the Foundation to deal with relevant matters, any third party necessary for the performance of contracts, any other business-related third party, government agencies, and other recipients not subject to international transmit restrictions imposed by the central competent authorities.</div>
                                </div>
                                <div class="sub-item">
                                    <span class="num">IV.</span>
                                    <div class="content">Methods: Your personal data will be utilized by automated or non-automated means, and in a reasonable manner. The methods of use include but are not limited to, verbal and written communications, telephone calls, text messages, emails, facsimiles, electronic documents, or any other proper means consistent with the technology available at the time.</div>
                                </div>
                            </div>
                        </div>
                        <div class="numbered-item">
                            <span class="num">4.</span>
                            <div class="content">
                                You may exercise the following rights with regard to your personal data by contacting the designated contact listed on the Foundation's official website: (1) the right to make an inquiry of and to review your personal data; (2) the right to request a copy of your personal data; (3) the right to supplement or correct your personal data; (4) the right to demand the cessation of the collection, processing or use of your personal data; and (5) the right to erase your personal data.<br>
                                The Foundation may, in accordance with the Personal Data Protection Act and other applicable laws and regulations or necessary for the performance of an official or business duty, or have been consented to by you in writing, reject your request to exercise the abovementioned rights.<br>
                                If you suffer any loss of rights or benefits from exercising the abovementioned rights, the Foundation will not be liable for any related compensation.
                            </div>
                        </div>
                        <div class="numbered-item">
                            <span class="num">5.</span>
                            <div class="content">
                                You are free to decide whether to provide your personal data. However, if you choose not to provide your personal data, the Foundation may be unable to provide services relevant to the purposes for which the data is collected.
                            </div>
                        </div>
                        <div class="numbered-item">
                            <span class="num">6.</span>
                            <div class="content">
                                In the event that any litigious proceedings arise relating to the Consent Form, you agree that such proceedings shall be governed and interpreted by the laws of the Republic of China, and the Taiwan Hualien District Court shall be the court of first instance.
                            </div>
                        </div>
                        <div class="numbered-item">
                            <span class="num">7.</span>
                            <div class="content">
                                You agree that the Foundation may keep the Consent Form for the purpose of future reference and verification.
                            </div>
                        </div>
                        <div class="consent-notice">
                            <p class="notice-highlight">
                                ※By providing your personal information in the relevant documents, you are deemed to have consented to providing your personal data to the Foundation as follows:
                            </p>
                            <p>You have read, understood, and agreed to the terms of the Consent Form, and agree to the Foundation's collection, processing, and use of your personal data within the necessary scope of specific purposes as set forth herein.</p>
                            <p>If you are under the age of 18, you confirm that your guardian has read, understood, and agreed to all the contents of the Consent Form, and shall comply with all provisions herein before providing any personal data.</p>
                            <p>If you are filling in the form on behalf of another individual, you warrant that you have fully explained the contents of this Consent Form to the data subject and have obtained his/her consent before providing any personal data.</p>
                        </div>
                    </template>
                </div>
                <p class="consent-note">
                    {{ $t('IncubatorApply.Consent.note') }}
                </p>
            </div>
            <div class="consent-checkbox">
                <v-checkbox
                    v-model="agreed"
                    :label="$t('IncubatorApply.Consent.checkbox')"
                    color="#F97E2B"
                />
            </div>
            <div class="consent-actions">
                <div
                    class="btn orange-btn"
                    :class="{ disabled: !agreed }"
                    @click="nextStep"
                >
                    {{ $t('IncubatorApply.Consent.button') }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
    computed: {
        ...mapState('mIncubatorApply', ['consentAgreed']),
        applyId() {
            return this.$route.params.id;
        },
        isZh() {
            const locale = this.$i18n.locale || '';
            return locale.toLowerCase().startsWith('zh');
        },
        agreed: {
            get() {
                return this.consentAgreed;
            },
            set(value) {
                this.setConsentAgreed(value);
            },
        },
    },
    methods: {
        ...mapMutations('mIncubatorApply', ['setConsentAgreed']),
        nextStep() {
            if (!this.agreed) return;
            this.$router.push({
                name: 'IncubatorTeamData',
                params: { id: this.applyId },
            });
        },
    },
};
</script>

<style lang="scss">
.incubator-consent {
    .apply-form-block {
        flex-direction: column;
        align-items: stretch;
    }

    .consent-container {
        width: 100%;
        border: 1px solid #e0e0e0;
        border-radius: 8px;
        padding: 40px;
        max-height: 70vh;
        overflow-y: auto;
    }

    .consent-title {
        font-weight: 700;
        font-size: 20px;
        text-align: center;
        color: #404040;
        margin-bottom: 20px;
    }

    .consent-intro {
        font-size: 16px;
        color: #404040;
        line-height: 1.8;
        margin-bottom: 4px;
    }

    .consent-scroll-area {
        background-color: #ffffff;
        margin: 16px 0 20px;

        .lead {
            font-size: 15px;
            color: #404040;
            line-height: 2;
            margin-bottom: 8px;
        }
    }

    .numbered-item {
        display: flex;
        font-size: 15px;
        color: #404040;
        line-height: 2;
        margin-bottom: 8px;

        > .num {
            flex-shrink: 0;
            min-width: 2.5em;
        }

        > .content {
            flex: 1;
        }
    }

    .sub-item {
        display: flex;
        font-size: 15px;
        color: #404040;
        line-height: 2;
        margin-top: 4px;

        > .num {
            flex-shrink: 0;
            min-width: 3em;
        }

        > .content {
            flex: 1;
        }
    }

    .consent-notice {
        margin-top: 20px;
        padding-top: 16px;
        border-top: 1px solid #e0e0e0;

        p {
            font-size: 15px;
            color: #404040;
            line-height: 2;
            margin-bottom: 8px;
        }

        .notice-highlight {
            font-weight: 700;
        }
    }

    .consent-note {
        font-size: 15px;
        color: #404040;
        line-height: 1.8;
        margin-bottom: 0;
        white-space: pre-line;
    }

    .consent-checkbox {
        display: flex;
        justify-content: center;
        margin-top: 24px;

        .v-label {
            color: #404040;
            font-weight: 700;
            font-size: 16px;
        }
    }

    .consent-actions {
        display: flex;
        justify-content: center;
        margin-top: 8px;

        .btn {
            width: 200px;
            padding: 16px;
            font-weight: 700;
            font-size: 18px;
            line-height: 1;
            letter-spacing: 0.1em;
            border-radius: 5px;
            text-align: center;
            cursor: pointer;

            &.disabled {
                opacity: 0.5;
                cursor: not-allowed;
            }
        }
    }
}
</style>
